import { BaseEnum } from '../../../enums/baseEnum';

const listJobModalityEnum: Array<JobModality> = [];

export class JobModality extends BaseEnum {
    static InSite = new JobModality(0, 'InSite', 'Presencial', 'success');
    static HomeOffice = new JobModality(1, 'HomeOffice', 'Home Office', 'info');
    static Hybrid = new JobModality(2, 'Hybrid', 'Híbrido', 'warning');

    constructor(
        public id: number,
        public value: string,
        public label: string,
        public className: string
    ) {
        super(id, value, label, className);
        listJobModalityEnum.push(this);
    }

    public static buildListEnum(): Array<BaseEnum> {
        return listJobModalityEnum;
    }
}
